/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface CalculateMask
 */
export interface CalculateMask {
    /**
     * 
     * @type {number}
     * @memberof CalculateMask
     */
    'clientId'?: number;
    /**
     * 
     * @type {Array<Service>}
     * @memberof CalculateMask
     */
    'services'?: Array<Service>;
}
/**
 * 
 * @export
 * @interface CalculateServices
 */
export interface CalculateServices {
    /**
     * 
     * @type {number}
     * @memberof CalculateServices
     */
    'clientId'?: number;
    /**
     * 
     * @type {Array<Service>}
     * @memberof CalculateServices
     */
    'services'?: Array<Service>;
    /**
     * 
     * @type {number}
     * @memberof CalculateServices
     */
    'height'?: number;
    /**
     * 
     * @type {number}
     * @memberof CalculateServices
     */
    'length'?: number;
    /**
     * 
     * @type {number}
     * @memberof CalculateServices
     */
    'width'?: number;
    /**
     * 
     * @type {number}
     * @memberof CalculateServices
     */
    'weight'?: number;
}
/**
 * 
 * @export
 * @interface CalculatedServices
 */
export interface CalculatedServices {
    /**
     * 
     * @type {number}
     * @memberof CalculatedServices
     */
    'clientId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CalculatedServices
     */
    'mask'?: string;
    /**
     * 
     * @type {number}
     * @memberof CalculatedServices
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof CalculatedServices
     */
    'weight'?: number;
}
/**
 * 
 * @export
 * @interface MaskMeta
 */
export interface MaskMeta {
    /**
     * 
     * @type {string}
     * @memberof MaskMeta
     */
    'mask'?: string;
}
/**
 * 
 * @export
 * @interface Service
 */
export interface Service {
    /**
     * 
     * @type {string}
     * @memberof Service
     */
    'key'?: ServiceKeyEnum;
    /**
     * 
     * @type {string}
     * @memberof Service
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof Service
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Service
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof Service
     */
    'groupName'?: string;
    /**
     * 
     * @type {number}
     * @memberof Service
     */
    'maskOrder'?: number;
}

export const ServiceKeyEnum = {
    AdditionalPackaging1: 'ADDITIONAL_PACKAGING_1',
    AdditionalPackaging5: 'ADDITIONAL_PACKAGING_5',
    AdditionalBoxSmall: 'ADDITIONAL_BOX_SMALL',
    AdditionalBoxMedium: 'ADDITIONAL_BOX_MEDIUM',
    AdditionalBoxLarge: 'ADDITIONAL_BOX_LARGE',
    FoamSealant2: 'FOAM_SEALANT_2',
    BubbleWrapPackage: 'BUBBLE_WRAP_PACKAGE',
    StretchWrap35: 'STRETCH_WRAP_3_5',
    SealingMaterialPaper: 'SEALING_MATERIAL_PAPER',
    PhotoOfGoods: 'PHOTO_OF_GOODS',
    VideoOfProcessing: 'VIDEO_OF_PROCESSING'
} as const;

export type ServiceKeyEnum = typeof ServiceKeyEnum[keyof typeof ServiceKeyEnum];

/**
 * 
 * @export
 * @interface ServiceTariff
 */
export interface ServiceTariff {
    /**
     * 
     * @type {number}
     * @memberof ServiceTariff
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServiceTariff
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServiceTariff
     */
    'clientId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ServiceTariff
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ServiceTariff
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceTariff
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {Service}
     * @memberof ServiceTariff
     */
    'service'?: Service;
    /**
     * 
     * @type {string}
     * @memberof ServiceTariff
     */
    'service_key'?: ServiceTariffServiceKeyEnum;
}

export const ServiceTariffServiceKeyEnum = {
    AdditionalPackaging1: 'ADDITIONAL_PACKAGING_1',
    AdditionalPackaging5: 'ADDITIONAL_PACKAGING_5',
    AdditionalBoxSmall: 'ADDITIONAL_BOX_SMALL',
    AdditionalBoxMedium: 'ADDITIONAL_BOX_MEDIUM',
    AdditionalBoxLarge: 'ADDITIONAL_BOX_LARGE',
    FoamSealant2: 'FOAM_SEALANT_2',
    BubbleWrapPackage: 'BUBBLE_WRAP_PACKAGE',
    StretchWrap35: 'STRETCH_WRAP_3_5',
    SealingMaterialPaper: 'SEALING_MATERIAL_PAPER',
    PhotoOfGoods: 'PHOTO_OF_GOODS',
    VideoOfProcessing: 'VIDEO_OF_PROCESSING'
} as const;

export type ServiceTariffServiceKeyEnum = typeof ServiceTariffServiceKeyEnum[keyof typeof ServiceTariffServiceKeyEnum];

/**
 * 
 * @export
 * @interface SetTariff
 */
export interface SetTariff {
    /**
     * 
     * @type {string}
     * @memberof SetTariff
     */
    'serviceKey'?: SetTariffServiceKeyEnum;
    /**
     * 
     * @type {number}
     * @memberof SetTariff
     */
    'price'?: number;
}

export const SetTariffServiceKeyEnum = {
    AdditionalPackaging1: 'ADDITIONAL_PACKAGING_1',
    AdditionalPackaging5: 'ADDITIONAL_PACKAGING_5',
    AdditionalBoxSmall: 'ADDITIONAL_BOX_SMALL',
    AdditionalBoxMedium: 'ADDITIONAL_BOX_MEDIUM',
    AdditionalBoxLarge: 'ADDITIONAL_BOX_LARGE',
    FoamSealant2: 'FOAM_SEALANT_2',
    BubbleWrapPackage: 'BUBBLE_WRAP_PACKAGE',
    StretchWrap35: 'STRETCH_WRAP_3_5',
    SealingMaterialPaper: 'SEALING_MATERIAL_PAPER',
    PhotoOfGoods: 'PHOTO_OF_GOODS',
    VideoOfProcessing: 'VIDEO_OF_PROCESSING'
} as const;

export type SetTariffServiceKeyEnum = typeof SetTariffServiceKeyEnum[keyof typeof SetTariffServiceKeyEnum];

/**
 * 
 * @export
 * @interface Tariff
 */
export interface Tariff {
    /**
     * 
     * @type {number}
     * @memberof Tariff
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Tariff
     */
    'createdAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Tariff
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Tariff
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Tariff
     */
    'key'?: string;
}
/**
 * 
 * @export
 * @interface TariffIdentity
 */
export interface TariffIdentity {
    /**
     * 
     * @type {string}
     * @memberof TariffIdentity
     */
    'serviceKey'?: TariffIdentityServiceKeyEnum;
}

export const TariffIdentityServiceKeyEnum = {
    AdditionalPackaging1: 'ADDITIONAL_PACKAGING_1',
    AdditionalPackaging5: 'ADDITIONAL_PACKAGING_5',
    AdditionalBoxSmall: 'ADDITIONAL_BOX_SMALL',
    AdditionalBoxMedium: 'ADDITIONAL_BOX_MEDIUM',
    AdditionalBoxLarge: 'ADDITIONAL_BOX_LARGE',
    FoamSealant2: 'FOAM_SEALANT_2',
    BubbleWrapPackage: 'BUBBLE_WRAP_PACKAGE',
    StretchWrap35: 'STRETCH_WRAP_3_5',
    SealingMaterialPaper: 'SEALING_MATERIAL_PAPER',
    PhotoOfGoods: 'PHOTO_OF_GOODS',
    VideoOfProcessing: 'VIDEO_OF_PROCESSING'
} as const;

export type TariffIdentityServiceKeyEnum = typeof TariffIdentityServiceKeyEnum[keyof typeof TariffIdentityServiceKeyEnum];

/**
 * 
 * @export
 * @interface TariffRate
 */
export interface TariffRate {
    /**
     * 
     * @type {number}
     * @memberof TariffRate
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof TariffRate
     */
    'fromWeight'?: number;
    /**
     * 
     * @type {number}
     * @memberof TariffRate
     */
    'toWeight'?: number;
    /**
     * 
     * @type {string}
     * @memberof TariffRate
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof TariffRate
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof TariffRate
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof TariffRate
     */
    'tariff_id'?: number;
}
/**
 * 
 * @export
 * @interface UpdateRateRequest
 */
export interface UpdateRateRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateRateRequest
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateRateRequest
     */
    'id'?: number;
}

/**
 * ServiceControllerApi - axios parameter creator
 * @export
 */
export const ServiceControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CalculateServices} calculateServices 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculate: async (calculateServices: CalculateServices, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calculateServices' is not null or undefined
            assertParamExists('calculate', 'calculateServices', calculateServices)
            const localVarPath = `/services/calculate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(calculateServices, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForClient: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/services`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CalculateMask} calculateMask 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMask: async (calculateMask: CalculateMask, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calculateMask' is not null or undefined
            assertParamExists('getMask', 'calculateMask', calculateMask)
            const localVarPath = `/services/mask`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(calculateMask, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServiceControllerApi - functional programming interface
 * @export
 */
export const ServiceControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ServiceControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CalculateServices} calculateServices 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculate(calculateServices: CalculateServices, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalculatedServices>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculate(calculateServices, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceControllerApi.calculate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getForClient(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Service>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getForClient(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceControllerApi.getForClient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CalculateMask} calculateMask 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMask(calculateMask: CalculateMask, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MaskMeta>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMask(calculateMask, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceControllerApi.getMask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ServiceControllerApi - factory interface
 * @export
 */
export const ServiceControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ServiceControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {CalculateServices} calculateServices 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculate(calculateServices: CalculateServices, options?: RawAxiosRequestConfig): AxiosPromise<CalculatedServices> {
            return localVarFp.calculate(calculateServices, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForClient(options?: RawAxiosRequestConfig): AxiosPromise<Array<Service>> {
            return localVarFp.getForClient(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CalculateMask} calculateMask 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMask(calculateMask: CalculateMask, options?: RawAxiosRequestConfig): AxiosPromise<MaskMeta> {
            return localVarFp.getMask(calculateMask, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ServiceControllerApi - object-oriented interface
 * @export
 * @class ServiceControllerApi
 * @extends {BaseAPI}
 */
export class ServiceControllerApi extends BaseAPI {
    /**
     * 
     * @param {CalculateServices} calculateServices 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceControllerApi
     */
    public calculate(calculateServices: CalculateServices, options?: RawAxiosRequestConfig) {
        return ServiceControllerApiFp(this.configuration).calculate(calculateServices, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceControllerApi
     */
    public getForClient(options?: RawAxiosRequestConfig) {
        return ServiceControllerApiFp(this.configuration).getForClient(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CalculateMask} calculateMask 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceControllerApi
     */
    public getMask(calculateMask: CalculateMask, options?: RawAxiosRequestConfig) {
        return ServiceControllerApiFp(this.configuration).getMask(calculateMask, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ServiceTariffControllerApi - axios parameter creator
 * @export
 */
export const ServiceTariffControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} clientId 
         * @param {SetTariff} setTariff 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        add: async (clientId: number, setTariff: SetTariff, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('add', 'clientId', clientId)
            // verify required parameter 'setTariff' is not null or undefined
            assertParamExists('add', 'setTariff', setTariff)
            const localVarPath = `/services/tariffs/{clientId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setTariff, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} clientId 
         * @param {SetTariff} setTariff 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        change: async (clientId: number, setTariff: SetTariff, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('change', 'clientId', clientId)
            // verify required parameter 'setTariff' is not null or undefined
            assertParamExists('change', 'setTariff', setTariff)
            const localVarPath = `/services/tariffs/{clientId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setTariff, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} clientId 
         * @param {TariffIdentity} tariffIdentity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disable: async (clientId: number, tariffIdentity: TariffIdentity, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('disable', 'clientId', clientId)
            // verify required parameter 'tariffIdentity' is not null or undefined
            assertParamExists('disable', 'tariffIdentity', tariffIdentity)
            const localVarPath = `/services/tariffs/{clientId}/disable`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tariffIdentity, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} clientId 
         * @param {TariffIdentity} tariffIdentity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enable: async (clientId: number, tariffIdentity: TariffIdentity, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('enable', 'clientId', clientId)
            // verify required parameter 'tariffIdentity' is not null or undefined
            assertParamExists('enable', 'tariffIdentity', tariffIdentity)
            const localVarPath = `/services/tariffs/{clientId}/enable`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tariffIdentity, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} clientId 
         * @param {string} mask 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForClient1: async (clientId: number, mask: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getForClient1', 'clientId', clientId)
            // verify required parameter 'mask' is not null or undefined
            assertParamExists('getForClient1', 'mask', mask)
            const localVarPath = `/services/tariffs/{clientId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (mask !== undefined) {
                localVarQueryParameter['mask'] = mask;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServiceTariffControllerApi - functional programming interface
 * @export
 */
export const ServiceTariffControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ServiceTariffControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} clientId 
         * @param {SetTariff} setTariff 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async add(clientId: number, setTariff: SetTariff, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceTariff>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.add(clientId, setTariff, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceTariffControllerApi.add']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} clientId 
         * @param {SetTariff} setTariff 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async change(clientId: number, setTariff: SetTariff, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceTariff>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.change(clientId, setTariff, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceTariffControllerApi.change']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} clientId 
         * @param {TariffIdentity} tariffIdentity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disable(clientId: number, tariffIdentity: TariffIdentity, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceTariff>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disable(clientId, tariffIdentity, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceTariffControllerApi.disable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} clientId 
         * @param {TariffIdentity} tariffIdentity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enable(clientId: number, tariffIdentity: TariffIdentity, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceTariff>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enable(clientId, tariffIdentity, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceTariffControllerApi.enable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} clientId 
         * @param {string} mask 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getForClient1(clientId: number, mask: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServiceTariff>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getForClient1(clientId, mask, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceTariffControllerApi.getForClient1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ServiceTariffControllerApi - factory interface
 * @export
 */
export const ServiceTariffControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ServiceTariffControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} clientId 
         * @param {SetTariff} setTariff 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        add(clientId: number, setTariff: SetTariff, options?: RawAxiosRequestConfig): AxiosPromise<ServiceTariff> {
            return localVarFp.add(clientId, setTariff, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} clientId 
         * @param {SetTariff} setTariff 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        change(clientId: number, setTariff: SetTariff, options?: RawAxiosRequestConfig): AxiosPromise<ServiceTariff> {
            return localVarFp.change(clientId, setTariff, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} clientId 
         * @param {TariffIdentity} tariffIdentity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disable(clientId: number, tariffIdentity: TariffIdentity, options?: RawAxiosRequestConfig): AxiosPromise<ServiceTariff> {
            return localVarFp.disable(clientId, tariffIdentity, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} clientId 
         * @param {TariffIdentity} tariffIdentity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enable(clientId: number, tariffIdentity: TariffIdentity, options?: RawAxiosRequestConfig): AxiosPromise<ServiceTariff> {
            return localVarFp.enable(clientId, tariffIdentity, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} clientId 
         * @param {string} mask 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForClient1(clientId: number, mask: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServiceTariff>> {
            return localVarFp.getForClient1(clientId, mask, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ServiceTariffControllerApi - object-oriented interface
 * @export
 * @class ServiceTariffControllerApi
 * @extends {BaseAPI}
 */
export class ServiceTariffControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} clientId 
     * @param {SetTariff} setTariff 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceTariffControllerApi
     */
    public add(clientId: number, setTariff: SetTariff, options?: RawAxiosRequestConfig) {
        return ServiceTariffControllerApiFp(this.configuration).add(clientId, setTariff, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} clientId 
     * @param {SetTariff} setTariff 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceTariffControllerApi
     */
    public change(clientId: number, setTariff: SetTariff, options?: RawAxiosRequestConfig) {
        return ServiceTariffControllerApiFp(this.configuration).change(clientId, setTariff, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} clientId 
     * @param {TariffIdentity} tariffIdentity 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceTariffControllerApi
     */
    public disable(clientId: number, tariffIdentity: TariffIdentity, options?: RawAxiosRequestConfig) {
        return ServiceTariffControllerApiFp(this.configuration).disable(clientId, tariffIdentity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} clientId 
     * @param {TariffIdentity} tariffIdentity 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceTariffControllerApi
     */
    public enable(clientId: number, tariffIdentity: TariffIdentity, options?: RawAxiosRequestConfig) {
        return ServiceTariffControllerApiFp(this.configuration).enable(clientId, tariffIdentity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} clientId 
     * @param {string} mask 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceTariffControllerApi
     */
    public getForClient1(clientId: number, mask: string, options?: RawAxiosRequestConfig) {
        return ServiceTariffControllerApiFp(this.configuration).getForClient1(clientId, mask, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TariffControllerApi - axios parameter creator
 * @export
 */
export const TariffControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/tariffs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRatesForTariff: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRatesForTariff', 'id', id)
            const localVarPath = `/tariffs/{id}/rates`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRatesForTariff1: async (key: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('getRatesForTariff1', 'key', key)
            const localVarPath = `/tariffs/by-key/{key}/rates`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} rateId 
         * @param {UpdateRateRequest} updateRateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTariff: async (id: number, rateId: number, updateRateRequest: UpdateRateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTariff', 'id', id)
            // verify required parameter 'rateId' is not null or undefined
            assertParamExists('updateTariff', 'rateId', rateId)
            // verify required parameter 'updateRateRequest' is not null or undefined
            assertParamExists('updateTariff', 'updateRateRequest', updateRateRequest)
            const localVarPath = `/tariffs/{id}/rates/{rate_id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"rate_id"}}`, encodeURIComponent(String(rateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {Array<UpdateRateRequest>} updateRateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTariffRates: async (id: number, updateRateRequest: Array<UpdateRateRequest>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTariffRates', 'id', id)
            // verify required parameter 'updateRateRequest' is not null or undefined
            assertParamExists('updateTariffRates', 'updateRateRequest', updateRateRequest)
            const localVarPath = `/tariffs/{id}/rates`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TariffControllerApi - functional programming interface
 * @export
 */
export const TariffControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TariffControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Tariff>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TariffControllerApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRatesForTariff(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TariffRate>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRatesForTariff(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TariffControllerApi.getRatesForTariff']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRatesForTariff1(key: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TariffRate>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRatesForTariff1(key, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TariffControllerApi.getRatesForTariff1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} rateId 
         * @param {UpdateRateRequest} updateRateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTariff(id: number, rateId: number, updateRateRequest: UpdateRateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TariffRate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTariff(id, rateId, updateRateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TariffControllerApi.updateTariff']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {Array<UpdateRateRequest>} updateRateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTariffRates(id: number, updateRateRequest: Array<UpdateRateRequest>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTariffRates(id, updateRateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TariffControllerApi.updateTariffRates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TariffControllerApi - factory interface
 * @export
 */
export const TariffControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TariffControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<Tariff>> {
            return localVarFp.getAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRatesForTariff(id: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<TariffRate>> {
            return localVarFp.getRatesForTariff(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRatesForTariff1(key: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<TariffRate>> {
            return localVarFp.getRatesForTariff1(key, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} rateId 
         * @param {UpdateRateRequest} updateRateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTariff(id: number, rateId: number, updateRateRequest: UpdateRateRequest, options?: RawAxiosRequestConfig): AxiosPromise<TariffRate> {
            return localVarFp.updateTariff(id, rateId, updateRateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {Array<UpdateRateRequest>} updateRateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTariffRates(id: number, updateRateRequest: Array<UpdateRateRequest>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateTariffRates(id, updateRateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TariffControllerApi - object-oriented interface
 * @export
 * @class TariffControllerApi
 * @extends {BaseAPI}
 */
export class TariffControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TariffControllerApi
     */
    public getAll(options?: RawAxiosRequestConfig) {
        return TariffControllerApiFp(this.configuration).getAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TariffControllerApi
     */
    public getRatesForTariff(id: number, options?: RawAxiosRequestConfig) {
        return TariffControllerApiFp(this.configuration).getRatesForTariff(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} key 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TariffControllerApi
     */
    public getRatesForTariff1(key: string, options?: RawAxiosRequestConfig) {
        return TariffControllerApiFp(this.configuration).getRatesForTariff1(key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {number} rateId 
     * @param {UpdateRateRequest} updateRateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TariffControllerApi
     */
    public updateTariff(id: number, rateId: number, updateRateRequest: UpdateRateRequest, options?: RawAxiosRequestConfig) {
        return TariffControllerApiFp(this.configuration).updateTariff(id, rateId, updateRateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {Array<UpdateRateRequest>} updateRateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TariffControllerApi
     */
    public updateTariffRates(id: number, updateRateRequest: Array<UpdateRateRequest>, options?: RawAxiosRequestConfig) {
        return TariffControllerApiFp(this.configuration).updateTariffRates(id, updateRateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



